import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import useLoadingStore from "../../store/loading";
import useModalStore from "../../store/modalStore";
import { api } from "../../services/api";
import { errorsMessage } from "../../helpers";

export function useTeam() {
  const [open, setOpen] = useState(false);
  const [results, setResults] = useState();
  const [term, setTerm] = useState("");
  const [team, setTeam] = useState({});
  const { setLoadingTable } = useLoadingStore(state => state);
  const { modalOpen, showModal, hideModal } = useModalStore(state => state);

  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilter = () => {
    const filters = {};
    if (term?.length > 0) filters.term = term;
    return filters;
  };

  const getList = async (page = 1, limit = 10) => {
    try {
      setLoadingTable(true);

      const { data } = await api.get(`/equipes`, {
        params: {
          filters: handleFilter(),
          page,
          limit
        }
      });

      setResults(data?.data || {});
    } catch (err) {
      errorsMessage(err, enqueueSnackbar);
    } finally {
      setLoadingTable(false);
    }
  };

  const handleSearch = () => {
    getList();
  };

  const handleOpen = (status = true) => {
    setOpen(status);
    if (!status) setTeam({});
  };

  const handleEdit = item => {
    setTeam(item);
    handleOpen();
  };

  const handleShow = item => {
    setTeam(item);
    showModal();
  };

  const handleClose = () => {
    setTeam(null);
    hideModal();
  };

  const handleDelete = async () => {
    try {
      await api.delete(`/equipes/${team.Id}`);
      handleClose();
      getList();
      enqueueSnackbar("Registro deletado com sucesso", {
        variant: "success"
      });
    } catch (err) {
      errorsMessage(err, enqueueSnackbar);
    }
  };

  return {
    results,
    term,
    setTerm,
    handleSearch,
    open,
    handleOpen,
    team,
    handleEdit,
    getList,
    handleShow,
    modalOpen,
    hideModal,
    handleClose,
    handleDelete
  };
}
